import React, { useMemo } from 'react'
import { ValueFormType, UseDefineSubmittedDate } from './defineSubmittedDateType'
import { SpecifyReceiveDocumentDateRequestType } from '../../../../../services/web/types/requestWebServiceTypes'
import checkPermission from '../../../../../utilities/checkPermission'
import moment from 'moment'
import useAppFolderAndTabAction from '../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import { convertDateToDateString, dateForAPI } from '../../../../../utilities/date'
import _ from 'lodash'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import { useHistory } from 'react-router-dom'
import useTranslate from '../../../../../i18n/useTranslate'
import useWebService from '../../../../../services/web/useWebService'
import useLoading from '../../../../../control/loading/useLoading'
import authenStore from '../../../../../stores/authen/authenStore'
import { DialogType } from '../../../../../control/dialog/dialog'
import { RoutePath } from '../../../../../router/routesConfig'
import useFolderAndTab from '../../useFolderAndTab'
import { TabSelectedType } from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import constConsiderType from '../../../../../constants/considerType'
import { FormApi, ValidationErrors } from 'final-form'
const useSpecifyDateForm = (props: UseDefineSubmittedDate) => {
    const { callbackSaveComplete } = props
    const [initialValues, setInitialValues] = React.useState<any>({})
    const checkPermissionHook = checkPermission()
    const { projectData } = useManageProjectStore()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const isShowUpdateDate = checkPermissionHook.chkShowUpdateDate(projectData)
    const [minMaxDate, setMinMaxDate] = React.useState<
        { min: string | undefined; max: string | undefined } | undefined
    >()
    const [displayField, setDisplayField] = React.useState<{ docDate: boolean; commentaryDate: boolean } | undefined>()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const history = useHistory()
    const translate = useTranslate()
    const callWebService = useWebService()
    const loadingHook = useLoading()
    const profileStore = authenStore()
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const commentaryDateRef = React.useRef<string>('')
    const advisorDateRef = React.useRef<string>('')
    const paramsRef = React.useRef<SpecifyReceiveDocumentDateRequestType>()
    const tabAndFolderHook = useFolderAndTab()
    const isSubmittedReceiveDate = useMemo(() => {
        return projectData?.isSubmittedReceiveDate ?? false
    }, [projectData])

    React.useEffect(() => {
        /* considerInfo 
            id:1 => Full Board +10 day //irb1 45
            id:2 => Expedited + 10 day //irb1 45
            id:3 => Exempt + 7 day //irb1 20
        */
        if (projectData) {
            const isDisplayField = {
                docDate: projectData?.isRequestDocument,
                commentaryDate: projectData?.committeeInfo.length > 0,
            }
            setDisplayField(isDisplayField)
        }
        //irbType ใช้สำหรับเลือก Flow ต้นแบบว่าจะเป็นแบบ 1 หรือ 2
        if (projectData?.irbType === 1) {
            createInitialDataREC1()
        } else if (projectData?.irbType === 2) {
            createInitialDataREC2()
        }
    }, [projectData?.projectID ?? null, projectData?.submittedID ?? null])

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    /**
     *
     * REC1
     */
    const createInitialDataREC1 = () => {
        if (projectData) {
            const isRequestDocument = projectData?.isRequestDocument
            const isExempt = projectData?.considerInfo?.value === constConsiderType.exempt
            const addDay = isExempt ? 20 : 45
            const isCurrentDate = new Date() // วันปัจจุบัน
            const defaultAnnounceDate = moment(isCurrentDate).add(addDay, 'day').format('YYYY-MM-DD')

            const initialData = {
                docDate: projectData?.receiveDocumentDate,
                commentaryDate: projectData?.sendCommentCommitteeDate,
                announceDate: projectData?.announceDate
                    ? projectData?.announceDate
                    : !isRequestDocument
                    ? defaultAnnounceDate
                    : null,
                advisorDueDate: projectData?.sendAdvisorDueDate,
            }
            setMinMaxDate({
                min: initialData.docDate ? moment(initialData.docDate).format('YYYY-MM-DD') : undefined,
                max: initialData.announceDate ?? undefined,
            })
            setInitialValues(initialData)
        }
    }

    const handleChangCommentDateREC1 = (val: string) => {
        commentaryDateRef.current = val
    }

    const handleChangDocDateREC1 = (
        val: string,
        // change: <F extends keyof ValueFormType>(name: F, value?: ValueFormType[F] | undefined) => void,
        form: FormApi<ValueFormType, Partial<ValueFormType>>,
    ) => {
        if (val !== 'undefined') {
            const isExempt = projectData && projectData?.considerInfo?.value === constConsiderType.exempt
            const addDay = isExempt ? 20 : 45
            const announceDate = moment(val).add(addDay, 'day').format('YYYY-MM-DD')
            const formValAnnounceDate = form.getFieldState('announceDate')?.value
            setMinMaxDate({
                min: moment(val).format('YYYY-MM-DD'),
                max: formValAnnounceDate ? formValAnnounceDate : announceDate,
            })
        } else {
            setMinMaxDate({
                min: undefined,
                max: minMaxDate?.max,
            })
        }
    }

    const resetDateExceptDocDate = (form: FormApi<ValueFormType, Partial<ValueFormType>>) => {
        const formVal = form.getState().values
        if (formVal.docDate) {
            const docDate = moment(formVal.docDate)
            if (formVal.announceDate && moment(formVal.announceDate) < docDate) {
                setMinMaxDate({
                    min: formVal.docDate,
                    max: formVal.docDate,
                })
                form.change('announceDate', formVal.docDate)
            }
            if (formVal.advisorDueDate && moment(formVal.advisorDueDate) < docDate) {
                form.change('advisorDueDate', formVal.docDate)
            }
            if (formVal.commentaryDate && moment(formVal.commentaryDate) < docDate) {
                form.change('commentaryDate', formVal.docDate)
            }
        } else if (!formVal.docDate) {
            form.change('advisorDueDate', null)
            form.change('announceDate', null)
            form.change('commentaryDate', null)
        }
    }

    const handleChangAnnounceDateREC1 = (
        val: string,
        // change: <F extends keyof ValueFormType>(name: F, value?: ValueFormType[F] | undefined) => void,
        form: FormApi<ValueFormType, Partial<ValueFormType>>,
    ) => {
        if (val !== 'undefined') {
            const isRequestDocument = projectData?.isRequestDocument
            const isExempt = projectData && projectData?.considerInfo?.value === constConsiderType.exempt
            const subtractDay = isExempt ? 20 : 45
            const docDate = moment(val).subtract(subtractDay, 'day').format('YYYY-MM-DD')
            const announceDate = new Date(val)
            const newDocDate = new Date(docDate)
            let commentaryDate //วันที่กรรมการลงความเห็น
            const formValDocDate = form.getFieldState('docDate')?.value

            if (commentaryDateRef.current) {
                commentaryDate = new Date(commentaryDateRef.current)
            }

            if (isRequestDocument) {
                if (commentaryDate && (newDocDate > commentaryDate || commentaryDate > announceDate)) {
                    form.change('commentaryDate', null)
                }
            } else {
                if (commentaryDate && commentaryDate > announceDate) {
                    form.change('commentaryDate', null)
                }
            }

            if (!formValDocDate) {
                if (isRequestDocument) {
                    form.change('docDate', docDate)
                }
            }

            setMinMaxDate({
                min: isRequestDocument ? (formValDocDate ? formValDocDate : docDate) : undefined,
                max: moment(val).format('YYYY-MM-DD'),
            })
        } else {
            setMinMaxDate({
                min: minMaxDate?.min,
                max: undefined,
            })
        }
    }

    const handleChangAdvisorDateREC1 = (val: string) => {
        advisorDateRef.current = val
    }

    /**
     *
     * REC2
     */
    const createInitialDataREC2 = () => {
        if (projectData) {
            const isRequestDocument = projectData?.isRequestDocument
            const isExempt = projectData?.considerInfo?.value === constConsiderType.exempt
            const addDay = isExempt ? 7 : 10
            const isCurrentDate = new Date() // วันปัจจุบัน
            const defaultAnnounceDate = moment(isCurrentDate).add(addDay, 'day').format('YYYY-MM-DD')

            const initialData = {
                docDate: projectData?.receiveDocumentDate,
                commentaryDate: projectData?.sendCommentCommitteeDate,
                announceDate: projectData?.announceDate
                    ? projectData?.announceDate
                    : !isRequestDocument
                    ? defaultAnnounceDate
                    : null,
                advisorDueDate: projectData?.sendAdvisorDueDate,
            }
            setMinMaxDate({
                min: initialData.docDate ? moment(initialData.docDate).format('YYYY-MM-DD') : undefined,
                max: initialData.announceDate ?? undefined,
            })
            setInitialValues(initialData)
        }
    }

    const handleChangCommentDateREC2 = (val: string) => {
        commentaryDateRef.current = val
    }

    const handleChangDocDateREC2 = (
        val: string,
        // change: <F extends keyof ValueFormType>(name: F, value?: ValueFormType[F] | undefined) => void,
        form: FormApi<ValueFormType, Partial<ValueFormType>>,
    ) => {
        if (val !== 'undefined') {
            const isExempt = projectData && projectData?.considerInfo?.value === constConsiderType.exempt
            const addDay = isExempt ? 7 : 10
            const announceDate = moment(val).add(addDay, 'day').format('YYYY-MM-DD')
            const formValAnnounceDate = form.getFieldState('announceDate')?.value
            setMinMaxDate({
                min: moment(val).format('YYYY-MM-DD'),
                max: formValAnnounceDate ? formValAnnounceDate : announceDate,
            })
        } else {
            setMinMaxDate({
                min: undefined,
                max: minMaxDate?.max,
            })
        }
    }

    const handleChangAnnounceDateREC2 = (
        val: string,
        // change: <F extends keyof ValueFormType>(name: F, value?: ValueFormType[F] | undefined) => void,
        form: FormApi<ValueFormType, Partial<ValueFormType>>,
    ) => {
        if (val !== 'undefined') {
            const isRequestDocument = projectData?.isRequestDocument
            const isExempt = projectData && projectData?.considerInfo?.value === constConsiderType.exempt
            const subtractDay = isExempt ? 7 : 10
            const docDate = moment(val).subtract(subtractDay, 'day').format('YYYY-MM-DD')
            const announceDate = new Date(val)
            const newDocDate = new Date(docDate)
            let commentaryDate //วันที่กรรมการลงความเห็น
            const formValDocDate = form.getFieldState('docDate')?.value

            if (commentaryDateRef.current) {
                commentaryDate = new Date(commentaryDateRef.current)
            }

            if (isRequestDocument) {
                if (commentaryDate && (newDocDate > commentaryDate || commentaryDate > announceDate)) {
                    form.change('commentaryDate', null)
                }
            } else {
                if (commentaryDate && commentaryDate > announceDate) {
                    form.change('commentaryDate', null)
                }
            }

            if (!formValDocDate) {
                if (isRequestDocument) {
                    form.change('docDate', docDate)
                }
            }
            setMinMaxDate({
                min: isRequestDocument ? (formValDocDate ? formValDocDate : docDate) : undefined,
                max: moment(val).format('YYYY-MM-DD'),
            })
        } else {
            setMinMaxDate({
                min: minMaxDate?.min,
                max: undefined,
            })
        }
    }

    const handleChangAdvisorDateREC2 = (val: string) => {
        advisorDateRef.current = val
    }

    /**
     * process for save
     */

    const handleClickCancel = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',

                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }

    const handleSubmitForm = async (val: ValueFormType) => {
        const parameter: SpecifyReceiveDocumentDateRequestType | undefined = getParameterForSave(val)
        if (val.submitType === 'save') {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    if (
                        parameter?.receiveDocumentDate &&
                        !parameter.sendCommentCommitteeDate &&
                        !parameter.announceDate &&
                        !parameter.sendAdvisorDueDate
                    ) {
                        handleConfirmSubmitOnlyReceiveDate(parameter)
                    } else {
                        handleConfirmSave(parameter)
                    }
                },
            })
            dialogRef.current?.openDialog()
        } else {
            //ถ้า save draft ไม่ต้องมี alert confirm
            handleConfirmSave(parameter)
        }
    }
    const getParameterForSave = (val: ValueFormType) => {
        if (projectData) {
            let isDraft = false
            if (val.submitType === 'draft') {
                isDraft = true
            }
            const specifyReceiveDocumentDateRequest: SpecifyReceiveDocumentDateRequestType = {
                loginUserID: profileStore.profile.userId,
                projectID: projectData.projectID,
                submittedID: projectData.submittedID,
                receiveDocumentDate: val?.docDate ? dateForAPI(val?.docDate) ?? null : null,
                sendCommentCommitteeDate: val?.commentaryDate ? dateForAPI(val?.commentaryDate) ?? null : null,
                announceDate: val?.announceDate ? dateForAPI(val?.announceDate) ?? null : null,
                isDraft: isDraft,
                sendAdvisorDueDate: val.advisorDueDate ? dateForAPI(val?.advisorDueDate) ?? null : null,
            }
            return specifyReceiveDocumentDateRequest
        }
    }

    const handleConfirmSave = async (
        paramForSave: SpecifyReceiveDocumentDateRequestType | undefined,
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        if (paramForSave) {
            dialogRef.current?.closeDialog()
            const isDraft = paramForSave.isDraft ? paramForSave.isDraft : false
            loadingHook.loadingOpen()
            const res = await callWebService.specifyReceiveDocumentDate(paramForSave)

            if (!isFolder) {
                //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน folder ใช่หรือไม่?
                if (tabIndex && newTabSelected) {
                    //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน Tab ใช่หรือไม่?
                    tabAndFolderHook.setTab(tabIndex, newTabSelected)
                } else {
                    //หากเข้า else หมายความว่าเป็นการบันทึกจากกดปุ่มบันทึกไม่ใช่จากการติด dirty
                    if (callbackSaveComplete) {
                        if (res && res.status) {
                            callbackSaveComplete(res.status, isDraft)
                        }
                    }
                }
            }
            loadingHook.loadingClose()
        }
    }

    const handleConfirmSubmitOnlyReceiveDate = async (paramForSave: SpecifyReceiveDocumentDateRequestType) => {
        dialogRef.current?.closeDialog()
        loadingHook.loadingOpen()
        await callWebService
            .submitOnlyDocReceiveDate({
                projectID: paramForSave.projectID,
                submittedID: paramForSave.submittedID,
                receiveDocumentDate: paramForSave.receiveDocumentDate,
            })
            .then(() => {
                tabAndFolderHook.reloadProjectData(projectData?.projectID, projectData?.submittedID)
            })
        loadingHook.loadingClose()
    }

    /**
     *
     * Dirty tab
     */
    const handleDirtyChange = (props: any) => {
        let isDirty: boolean = false

        let newFormValue = {
            ...props.values,
            docDate: props.values.docDate ? convertDateToDateString(props.values.docDate) : null,
            commentaryDate: props.values.commentaryDate ? convertDateToDateString(props.values.commentaryDate) : null,
            announceDate: props.values.announceDate ? convertDateToDateString(props.values.announceDate) : null,
        }
        let initValue = {
            ...initialValues,
            docDate: initialValues.docDate ? convertDateToDateString(initialValues.docDate) : null,
            commentaryDate: initialValues.commentaryDate ? convertDateToDateString(initialValues.commentaryDate) : null,
            announceDate: initialValues.announceDate ? convertDateToDateString(initialValues.announceDate) : null,
        }

        const isEqual = _.isEqual(initValue, newFormValue)
        if (!isViewMode) {
            if (isEqual) {
                isDirty = false
            } else {
                isDirty = true
            }
        }

        // appFolderAndTabAction.setTabDirty(isDirty)
        paramsRef.current = getParameterForSave(props.values)

        const paramsDirty = {
            tabDirty: isDirty,
            callbackDirty: callbackDirtyProcess,
        }
        appFolderAndTabAction.setDirty(paramsDirty)
    }

    const callbackDirtyProcess = (
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        if (paramsRef.current) {
            paramsRef.current.isDraft = true
            handleConfirmSave(paramsRef.current, tabIndex, newTabSelected, isFolder)
        }
    }

    const conditionRequireAll = (formValues: ValueFormType) => {
        const condition1 = isSubmittedReceiveDate ? true : false
        const condition2 =
            formValues.docDate && (formValues.advisorDueDate || formValues.announceDate || formValues.commentaryDate)
                ? true
                : false
        return condition1 || condition2
    }

    const validateForm = (formValues: ValueFormType) => {
        const errors: ValidationErrors = {}
        const haveToFillAll = conditionRequireAll(formValues)
        let committee = projectData?.committeeInfo ?? []

        if (haveToFillAll) {
            if (committee.length > 0 && !formValues.advisorDueDate) {
                errors.advisorDueDate = translate.get('MESSAGE.M016')
            }
        }
        if (haveToFillAll && !formValues.announceDate) {
            errors.announceDate = translate.get('MESSAGE.M016')
        }
        if (haveToFillAll) {
            if (committee.length > 0 && !formValues.commentaryDate) {
                errors.commentaryDate = translate.get('MESSAGE.M016')
            }
        }
        return errors
    }

    return {
        minMaxDate,
        isViewMode,
        initialValues,
        configDialog,
        displayField,
        isShowUpdateDate,
        isSubmittedReceiveDate,
        conditionMinDate: minMaxDate && minMaxDate.min ? new Date(minMaxDate.min) : undefined,
        onRefDialog,
        onDirtyChang: handleDirtyChange,
        onChangDocDateREC1: handleChangDocDateREC1,
        onChangAnnounceDateREC1: handleChangAnnounceDateREC1,
        onChangDocDateREC2: handleChangDocDateREC2,
        onChangAnnounceDateREC2: handleChangAnnounceDateREC2,
        onChangCommentDateREC1: handleChangCommentDateREC1,
        onChangCommentDateREC2: handleChangCommentDateREC2,
        onSubmitForm: handleSubmitForm,
        onClickCancel: handleClickCancel,
        handleChangAdvisorDateREC1,
        handleChangAdvisorDateREC2,
        conditionRequireAll,
        validateForm,
        resetDateExceptDocDate,
    }
}

export default useSpecifyDateForm
